import {IMirrorWizardState} from "../../../types/ui/wizard/mirror";

export const initialMirrorState: IMirrorWizardState = {
};
